<template functional>
  <div class="noWrap">
    {{ props.value | CnpjFilter }}
  </div>
</template>

<script>
import CnpjFilter from 'Support/filters/formatCnpj';

export default {
  name: 'DataTableCnpjRow',
  filters: { CnpjFilter },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>
